import { RxUpdate } from "react-icons/rx";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/Header/NewHeader";
import { postAutoReview } from "../../store/middleware";
import SideMenu from "../../components/SideMenu/SideMenu";
import TableList from "../../components/elements/TableList";
import iconReportSVG from "../../assets/images/icons/report.svg";

function AutoReviewReport() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);

  const [data, setData] = useState([]);

  const getData = async () => {
    await dispatch(postAutoReview()).then((response) => setData(response));
  };

  const listItems = [{ label: "Msg", name: "msg" }];

  const listedItems = data?.map((item) => {
    return { msg: `${item?.msg}` };
  });

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  if (user?.role !== "companyManager") return <Navigate to="/" />;

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          icon={iconReportSVG}
          title="Auto Review Report"
          rightButton={<RxUpdate size={24} onClick={getData} />}
        />
        <div className="content" style={{ marginTop: 25 }}>
          <TableList component="autoReviewReport" listItems={listItems} listedItems={listedItems} />
        </div>
      </section>
    </div>
  );
}

export default AutoReviewReport;
